import { observer } from 'mobx-react-lite'
import { type ReactElement, useMemo } from 'react'
import { ContactsPageComponent } from 'app/components/contacts-page/ContactsPageComponent'
import { useContactsPage } from 'app/components/contacts-page/useContactsPage'
import { ListKindLine } from 'app/components/lists/ListKindLine'
import { PersonalListMarker } from 'app/components/lists/PersonalListMarker'
import type { List } from 'app/generated/graphql'
import { listRuleFilters } from 'lib/practiceLists'
import { isPersonalList } from 'lib/listVisibility'

export const FilterListTable = observer(function FilterListTable({
  list,
  viewToggle,
  titleActions,
}: {
  list: List
  viewToggle: ReactElement
  titleActions?: ReactElement
}): ReactElement {
  // Keyed on the rule, not the list object: a stage edit refetches the list but leaves the rule
  // alone, and a new rule object would rebuild the table's columns for nothing.
  const filterRule = useMemo(
    () => ({ id: list.id, name: list.name, filters: listRuleFilters(list), join: list.join ?? `and` }),
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- list.filters is the rule; `list` itself also changes with its stages
    [list.id, list.name, list.filters, list.join],
  )
  const props = useContactsPage({ filterRule })
  return (
    <ContactsPageComponent
      {...props}
      viewToggle={viewToggle}
      titleActions={titleActions}
      newContact={false}
      titleMarker={<PersonalListMarker personal={isPersonalList(list)} />}
      subheader={<ListKindLine kind="filter" />}
    />
  )
})
